import { render, staticRenderFns } from "./Write.vue?vue&type=template&id=ed51020c&scoped=true"
import script from "./Write.vue?vue&type=script&lang=js"
export * from "./Write.vue?vue&type=script&lang=js"
import style0 from "./Write.vue?vue&type=style&index=0&id=ed51020c&prod&scoped=true&lang=scss"
import style1 from "./Write.vue?vue&type=style&index=1&id=ed51020c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed51020c",
  null
  
)

export default component.exports